import { useCallback } from 'react';
import { APP_STORE_URL } from './constants';

export function useOpenApp(videoId?: string) {
  return useCallback(() => {
    const deeplink = `oasis://episode/${videoId}`;
    const ua = navigator.userAgent;
    const isIOS =
      /iPad|iPhone|iPod/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    if (isIOS) {
      let navigated = false;
      const onVisChange = () => {
        if (document.hidden) navigated = true;
      };
      document.addEventListener('visibilitychange', onVisChange);
      window.location.href = deeplink;

      setTimeout(() => {
        document.removeEventListener('visibilitychange', onVisChange);
        if (!navigated) {
          window.location.href = APP_STORE_URL;
        }
      }, 2500);
      return;
    }

    // Desktop / other fallback
    window.location.href = APP_STORE_URL;
  }, [videoId]);
}
